import { StockMovementsApiAdapter } from '../adapters/StockMovementsApiAdapter';
import { StockMovementsModel } from '../models/StockMovements';
import { Filters } from '../models/Filters';

export interface Page {
  stockmovements: StockMovementsModel[];
  nextPage?: number;
  hasMore: boolean;
  total: number;
}

export class Service {
  constructor(private apiAdapter: StockMovementsApiAdapter) {}

  async getAllMovements(): Promise<StockMovementsModel[]> {
    return this.apiAdapter.getAll();
  }

  async getPaginated(filters: Filters = {}): Promise<Page> {
    this.validateFilters(filters);
    return this.apiAdapter.getStockMovementsPaginated(filters);
  }

  async exportToExcel(filters: Filters = {}): Promise<string> {
    this.validateFilters(filters);
    return this.apiAdapter.exportToExcel(filters);
  }

  private validateFilters(filters: Filters): void {
    const { searchTerm, limit } = filters;

    if (limit && limit > 100) {
      throw new Error('El límite no puede ser mayor a 100');
    }

    if (searchTerm && searchTerm.length < 2) {
      throw new Error(
        'El término de búsqueda debe tener al menos 2 caracteres'
      );
    }
  }
}
